export default "__VITE_ASSET__KOkH$skW__"